<template>
    <transition name="banner">
        <div class="banner-cta" :class="[`type-${type}`]" v-if="!states.dismissed">
            <div class="cta-content">
                <div class="icon">
                    <slot name="icon">
                        <i class="icons8-bell"/>
                    </slot>
                </div>
                <div class="text" v-if="$slots.text">
                    <slot name="text"/>
                </div>
                <div class="button" v-if="$slots.button">
                    <slot name="button"/>
                </div>
                <div class="dismiss" v-if="dismissable">
                    <a href="#" @click.prevent="dismiss">
                        <slot name="close">
                            <i class="icons8-multiply-filled"/>
                        </slot>
                    </a>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'banner-cta',

        props: {
            type: {
                type: String,
                default() {
                    return 'banner';
                },
            },

            dismissable: {
                type: Boolean,
                default() {
                    return true;
                },
            },
        },

        data() {
            return {
                states: {
                    dismissed: false,
                },
            }
        },

        created() {
            this.$on('dismiss', this.dismiss);
        },

        methods: {
            /**
             * Close the banner
             */
            dismiss() {
                this.states.dismissed = true;
                this.$emit('dismissed');
            },
        },
    }
</script>

<style lang="less">
    @import (reference) "~assets/less/variables";

    .banner-cta {
        border-radius: 4px;
        color: #282c2e;
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
        margin-bottom: 12px;
        &.type-banner {
            background-image: linear-gradient(to right, extract(@yps-primary-palette, 1), extract(@yps-primary-palette, 3) 100%);
        }
        &.type-info {
            border: 1px dashed extract(@yps-semantic-palette, 1);
            font-weight: 600;
            .icon {
                color: @YPS-brand-secondary;
            }
        }
        .cta-content {
            padding: 11px 55px;
            position: relative;
            @media (min-width: @screen-sm-min) {
                padding: 0;
                display: table;
                > * {
                    display: table-cell;
                    vertical-align: middle;
                    padding: 11px;
                    &:first-child {
                        padding-left: 22px;
                    }
                }
            }
        }
        .icon,
        .dismiss {
            color: #ffffff;
            font-size: 1.9em;
            position: absolute;
            top: 11px;
            @media (min-width: @screen-sm-min) {
                position: static;
                width: 1%;
            }
            i {
                display: block;
            }
        }
        .icon {
            left: 11px;
        }
        .dismiss {
            color: #282c2e;
            right: 11px;
            a {
                color: inherit;
                &:hover {
                    opacity: 0.5;
                }
            }
        }
        .text {
            p {
                margin-bottom: 0;
            }
        }
        .button {
            margin-top: 1em;
            @media (min-width: @screen-sm-min) {
                margin-top: 0;
                width: 1%;
            }
            .btn {
                font-size: 12px;
                font-weight: 600;
                border-radius: 4px;
                padding: 8px 26px;
            }
        }
    }
    .banner-enter-active, .banner-leave-active {
        transition: opacity .5s;
    }
    .banner-enter, .banner-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
